import { render } from "./b-header.vue?vue&type=template&id=7ed6ac38&scoped=true&ts=true"
import script from "./b-header.vue?vue&type=script&lang=ts"
export * from "./b-header.vue?vue&type=script&lang=ts"

import "./b-header.vue?vue&type=style&index=0&id=7ed6ac38&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed6ac38"],['__file',"src/components/biz/b-header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed6ac38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed6ac38', __exports__)) {
    console.log('reload')
    api.reload('7ed6ac38', __exports__)
  }
  
  module.hot.accept("./b-header.vue?vue&type=template&id=7ed6ac38&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7ed6ac38', render)
  })

}


export default __exports__